<cdk-accordion-item #accordionItem="cdkAccordionItem" role="button" tabindex="0" [expanded]="false">
  <div (click)="accordionItem.toggle()">
    <div class="flex justify-between border-t border-text-white px-4 py-5">
      <h4 class="typo-h4-semibold">{{ question }}</h4>
      <svg-icon class="text-primary-blue" [key]="accordionItem.expanded ? 'px-16-arrow-up' : 'px-16-arrow-down'"></svg-icon>
    </div>
  </div>

  <div class="px-4 pb-6" [style.display]="accordionItem.expanded ? '' : 'none'">
    <p class="typo-h4-light font-light" [innerHTML]="answer | translate | markdown | async"></p>
  </div>
</cdk-accordion-item>
